import styled from 'styled-components';

import { ICON_TYPES, IconType } from '@components/Icon';

export const StyledResultIcons = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;

  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  z-index: 901;
`;

const ICON_TYPES_SET = new Set<string>(ICON_TYPES);

export const isIconType = (value: string): value is IconType => ICON_TYPES_SET.has(value);
